
'use client';

import { Award, Star, Users, Clock } from 'lucide-react';
import { Section } from '@/components/ui/section';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { SectionTitle, Lead } from '@/components/ui/typography';

const statsData = [
  {
    icon: Users,
    value: '560',
    label: 'Stagiaires formes en 2024',
    color: 'text-accent',
  },
  {
    icon: Clock,
    value: '10 281',
    label: 'Heures de formations',
    color: 'text-accent',
  },
  {
    icon: Star,
    value: '96%',
    label: 'Taux de satisfaction',
    color: 'text-accent',
  },
  {
    icon: Award,
    value: '99%',
    label: 'Taux de réussite',
    color: 'text-accent',
  },
];

const StatsSection = () => {
  return (
    <Section
      background="light"
      spacing="large"
      container={false}
      className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-[#06122F] via-[#050B18] to-[#0A1638] p-6 shadow-[0_20px_80px_-50px_rgba(0,0,0,0.8)] md:p-10 mb-12 md:mb-16"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-accent/15 blur-3xl" />
        <div className="absolute -bottom-28 -right-20 h-96 w-96 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent/60 to-transparent" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12">
          <SectionTitle center>Notre impact en chiffres</SectionTitle>
          <Lead center className="max-w-3xl mx-auto">
            Des résultats concrets qui témoignent de notre engagement et de la confiance de nos clients.
          </Lead>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <Card key={index} className="text-center transition-all duration-200 hover:-translate-y-0.5 hover:border-accent/25 hover:bg-white/10">
                <CardHeader className="flex flex-col items-center">
                  <div className="flex h-20 w-20 items-center justify-center rounded-3xl border border-white/10 bg-white/5">
                    <Icon className={`h-10 w-10 ${stat.color}`} />
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-5xl font-bold font-heading text-white">{stat.value}</p>
                  <p className="mt-2 text-lg font-medium text-white/70">{stat.label}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export { StatsSection };

